import React, { useEffect, useState } from "react";
import {
  CButton,
  CModal,
  CModalBody,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg"; 
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { addMakeRequest } from "../redux/makeDispatcher";
import { hideAddMakeModal, showAddMakeModal } from "../redux/makeModalDispatcher";
import Select from "react-select";

const AddMake = ({
   parentId = 0, 
   buttonLabel = "Add Make", 
   editMode = false,
   makeData = {},
   categories=[],
   data=null

   }) => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false); // Local State

  const [makeName, setMakeName] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
 

  const categoryOptions = React.useMemo(() => {
    if (data != null ) {
      const ids = data.category!= null ?data.category.split(',').map(Number):[];
      return categories
        .filter(cat => ids.includes(cat.id))
        .map(cat => ({
          value: cat.id,
          label: cat.name,
        }));
    } else {
      return categories.map((cat) => ({
        value: cat.id,
        label: cat.name,
      }));
    }
  }, [data, categories]);


  useEffect(() => {

    console.log("make parent id", data);
   

    if (editMode && makeData) {
      setMakeName(makeData.name || "");
      const selectedIds =makeData.category? makeData.category.split(',').map(Number): []; 

      const data = categories
        .filter(cat => selectedIds.includes(cat.id))
        .map(cat => ({
          value: cat.id,
          label: cat.name,
        }));

      setSelectedOptions(data);

    } 
  }, [editMode, makeData]);

  const resetForm = () => {
    setMakeName("");
    setSelectedOptions([]);

  };



  // Handle Add Make Submission
  const handleAddMake = () => {
    if (makeName.trim() === "") {
      if(parentId != 0)
      {
        alert("Model name is required");

      }
      else
      {
        alert("Make name is required");

      }
      return;
    }


    if(parentId == 0&& selectedOptions.length==0)
      {
        alert("Please select category");
        return;
      }


      
      if(parentId == 1 && selectedOptions== [] )
        {
          alert("Please select category");
          return;
        } 



    var data = {
  
      "name":makeName,
      "parent_id":"0",
      'category':parentId==0?selectedOptions.map(item => item.value).join(','):selectedOptions.value

      };





      if(parentId!=0){
        data['parent_id']=parentId;
      }
     
      if(editMode){
        data.id = makeData.id;
      }


      console.log("DTADTADTADTADT::::",data);

    dispatch(addMakeRequest(data));
   
    setIsModalVisible(false);
    dispatch(hideAddMakeModal());
  };

  return (
    <div>
      {/* Button to Open Modal */}
         <button
                onClick={() => {
                  if (!editMode) {
                    resetForm(); // Reset the form if adding
                  }
                  setIsModalVisible(true)
                  dispatch(showAddMakeModal())

                }}
                style={{
                  backgroundColor: editMode==true?"#1b87f4":"rgb(0 0 0)",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "4px",
                  fontSize:editMode==true?"10px":"14px",
                  minWidth:"60px",
                  // width: "100%",
                  height: editMode==true?"24px":"30px",  // Increased height
                  padding: editMode==true?"2px 5px":"4px 10px", // Added padding
                  display: "flex",
                  alignItems: "center",
                  // alignSelf:"end",
                  justifyContent: "center",
                }}
              >{buttonLabel}</button>
   

      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() =>setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          <div className="main-container createAdmin">
            {/* Close Button */}
            <div className="cross-btn-div d-flex">
              <img
                onClick={() =>setIsModalVisible(false)}
                src={crossButton}
                alt="close"
                className="cross-button"
              />
            </div>

            <form onSubmit={(e) => e.preventDefault()} className="login-form">
              <div className="mb-4">
                <h4
                  className="h4 fw-bold"
                  style={{ color: "#007bff", textAlign:"center" }}
                >
                  <b>{editMode===true? (parentId==0?"Edit Make":"Edit Model") : (parentId==0?"Add New Make":"Add New Model")}</b>
                </h4>
              </div>

             

              {/* Make Name Input */}
              <div className="mb-3 input-login-box">
                <input
                  value={makeName}
                  onChange={(e) => setMakeName(e.target.value)}
                  name="name"
                  type="text"
                  className="form-control login-input"
                  placeholder= {parentId ==0 ?"Enter make name":"Enter model name"}
                />
              </div>


                 
                 
                  <div className="mb-3 input-login-box">
                            
                    <Select
                      options={categoryOptions}
                     isMulti={parentId== 0}
                      value={selectedOptions}
                      onChange={setSelectedOptions}
                      placeholder="Select categories..."
                    />
              
              </div>

      


              {/* Submit Button */}
              <button
                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                type="button"
                onClick={handleAddMake}
              >
                  {editMode ? "Update" : "Submit"}
              </button>
            </form>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddMake;
